import { isSameDay } from '@/calendar/calendarDateUtils'

export function isSameCalendarDayAs(a, b) {
  const da = a instanceof Date ? a : new Date(a)
  const db = b instanceof Date ? b : new Date(b)
  if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) return false
  return isSameDay(da, db)
}

/**
 * Short heading for the calendar day of a message (Today, Yesterday, or date), relative to `now`.
 *
 * @param {string | number | Date | null | undefined} createdAt
 * @param {{ now?: Date }} [options]
 * @returns {string}
 */

export function formatConversationDayHeading(createdAt, options = {}) {
  let d
  if (createdAt === undefined || createdAt === null) {
    d = options.now ?? new Date()
  } else if (createdAt instanceof Date) {
    d = createdAt
  } else {
    d = new Date(createdAt)
  }

  if (Number.isNaN(d.getTime())) {
    return 'Today'
  }

  const reference = options.now ?? new Date()
  const yesterday = new Date(reference)
  yesterday.setDate(reference.getDate() - 1)

  if (isSameDay(d, reference)) return 'Today'
  if (isSameDay(d, yesterday)) return 'Yesterday'

  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    ...(d.getFullYear() !== reference.getFullYear() ? { year: 'numeric' } : {}),
  }).format(d)
}
